import React, { memo, useState, useEffect, Fragment } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  }
});

export default WithApp(function ModalOuput(props) {
  const classes = useStyles();
  const { ordersProducts = [], purchProducts = [], purchOrderId, purchaseId, reload } = props;
  const [comments, setComments] = useState({});
  const handleCommentChange = (itemCode, value) => {
    setComments(prev => ({ ...prev, [itemCode]: value }));
  };

  const matchedProducts = ordersProducts
    .map(orderItem => {
      const purchItem = purchProducts.find(p => p.ItemCode === orderItem.ItemCode);
      if (!purchItem) return null;

      const purchQuantity = Number(purchItem.quantity ?? 0);
      const orderQuantity = Number(orderItem.Quantity ?? 0);

      if (purchQuantity === orderQuantity) {
        return null;
      }

      return {
        ItemCode: orderItem.ItemCode,
        ItemName: orderItem.ItemName,
        orderQuantity,
        purchQuantity,
        difference: purchQuantity - orderQuantity,
      };
    })
    .filter(Boolean);

  // Para enviar en el dataForce (TODOS los productos)
  const allProductsToSend = purchProducts.map(purchItem => {
    const orderItem = ordersProducts.find(o => o.ItemCode === purchItem.ItemCode);
    const purchQuantity = Number(purchItem.quantity ?? 0);
    const orderQuantity = Number(orderItem?.Quantity ?? 0);

    return {
      ItemCode: purchItem.ItemCode,
      orderQuantity,
      purchQuantity,
      comment: comments[purchItem.ItemCode] || ''
    };
  });
  const getRowStyle = (difference) => {
    if (difference > 0) {
      return { backgroundColor: '#d2f8d2' };
    } else if (difference < 0) {
      return { backgroundColor: '#f8d2d2' };
    }
    return {};
  };
  return (
    <>
      <Modal 
        title={`Validación de orden de compra para mercadería XML`}
        model={{ open: props.open }}
        setOpen={props.onClose}
        showNotify={props.showNotify}
        reload={reload}
        entity={'purch/purchase-order-diferencia'}
        arrDataResponse
        dataForce={{
          purch_order_id: purchOrderId,
          products: allProductsToSend,
          validateOrder: 'Y',
          purch_purchase_id: purchaseId
        }}
      >
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="tabla de productos">
            <TableHead>
              <TableRow>
                <TableCell>Código</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell align="center">Cantidad Orden</TableCell>
                <TableCell align="center">Cantidad Compra</TableCell>
                <TableCell align="center">Comentario</TableCell>
              </TableRow>
            </TableHead>
              <TableBody>
                {purchProducts.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No se encontraron productos relacionados a esta compra. Selecciona otra para continuar con la validación
                    </TableCell>
                  </TableRow>
                )}

                {matchedProducts.length === 0 && purchProducts.length > 0 && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No se encontraron diferencias. Valida la orden de compra para continuar correctamente.
                    </TableCell>
                  </TableRow>
                )}

                {matchedProducts.map((product) => (
                  <TableRow
                    key={product.ItemCode}
                    style={getRowStyle(product.difference)}
                  >
                    <TableCell>{product.ItemCode}</TableCell>
                    <TableCell>{product.ItemName}</TableCell>
                    <TableCell align="center">{product.orderQuantity}</TableCell>
                    <TableCell align="center">{product.purchQuantity}</TableCell>
                    <TableCell align="center">
                      <TextField
                        fullWidth
                        label="Comentario"
                        type="text"
                        value={comments[product.ItemCode] || ''}
                        onChange={(e) => handleCommentChange(product.ItemCode, e.target.value)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
          </Table>
        </TableContainer>
      </Modal>
    </>
  );
});

